import type { GameModeId, TeamId } from "../levels/types";

export interface NetworkPlayerState {
  id: string;
  name: string;
  team?: TeamId;
  ready?: boolean;
}

export interface InputFrameMessage {
  t: "i";
  k: number;
  m: [number, number];
  l: [number, number];
  a: number;
}

export interface SnapshotPlayerState {
  id: string;
  n: string;
  p: [number, number, number];
  r: [number, number, number];
  h: number;
  team?: TeamId;
}

export interface SnapshotMessage {
  t: "s";
  k: number;
  tm: number;
  ps: SnapshotPlayerState[];
  mode: GameModeId;
}

export interface ControlMessage {
  t: "c";
  c:
    | "join-request"
    | "player-list"
    | "start-match"
    | "host-quit"
    | "joined"
    | "error";
  payload?: Record<string, unknown>;
}

export type NetworkMessage = InputFrameMessage | SnapshotMessage | ControlMessage;

export function encodeMessage(message: NetworkMessage) {
  return JSON.stringify(message);
}

export function decodeMessage(raw: string) {
  return JSON.parse(raw) as NetworkMessage;
}